import { component } from 'picoapp';
import loadScript from 'utils/load-script';

export default component(async () => {
  const { klaviyo: strings } = window.theme.strings;

  await loadScript('https://a.klaviyo.com/media/js/onsite/onsite.js');
  const { klaviyo } = window;

  window.klaviyo.init({
    account: theme.integrations.klaviyo,
    platform: 'shopify',
  });
  klaviyo.enable('backinstock', {
    trigger: {
      product_page_text: strings.trigger.productPageText,
      product_page_class: 'btn !mt-4 !w-full !justify-center',
      product_page_text_align: 'center',
      product_page_margin: '0',
      replace_anchor: false,
    },
    modal: {
      headline: strings.modal.headline,
      body_content: strings.modal.bodyContent,
      email_field_label: strings.modal.emailFieldLabel,
      button_label: strings.modal.buttonLabel,
      subscription_success_label: strings.modal.subscriptionSuccessLabel,
      footer_content: strings.modal.footerContent,
      additional_styles: '@import url("https://use.typekit.net/ptd4ira.css");',
      drop_background_color: '#000',
      background_color: '#fff',
      text_color: '#222',
      button_text_color: '#000',
      button_background_color: '#ff9000',
      close_button_color: '#ccc',
      error_background_color: '#fcd6d7',
      error_text_color: '#C72E2F',
      success_background_color: '#d3efcd',
      success_text_color: '#1B9500',
    },
  });
});
